import { SegmentService } from "@main-services/segment.service";
import { Injectable } from "@angular/core";
import { RudderstackService } from "@main-services/rudderstack.service";

@Injectable()
export class WalletDetailsTrackingService {
	constructor(
		private segmentService: SegmentService,
		private rudderstackService: RudderstackService
	) {}

	public trackWalletAddressViewed(symbol: string): void {
		this.segmentService.track({
			name: "Wallet Address Screen Viewed",
			properties: { asset: symbol }
		});
		this.rudderstackService.track({
			name: "Wallet Address Screen Viewed",
			properties: { asset: symbol }
		});
	}

	public trackCopyMemo(): void {
		this.segmentService.track({
			name: "Copy Memo Clicked"
		});
		this.rudderstackService.track({
			name: "Copy Memo Clicked"
		});
	}

	public trackCopyMessage(): void {
		this.segmentService.track({
			name: "Copy Message Clicked"
		});
		this.rudderstackService.track({
			name: "Copy Message Clicked"
		});
	}

	public trackCopyDestinationTag(): void {
		this.segmentService.track({
			name: "Copy Destination Tag Clicked"
		});
		this.rudderstackService.track({
			name: "Copy Destination Tag Clicked"
		});
	}

	public trackCopyWalletAddress(): void {
		this.segmentService.track({
			name: "Wallet Address Copy Wallet Address Clicked"
		});
		this.rudderstackService.track({
			name: "Wallet Address Copy Wallet Address Clicked"
		});
	}

	public trackCopyWalletOwner(): void {
		this.segmentService.track({
			name: "Wallet Owner Copy Wallet Owner Clicked"
		});
		this.rudderstackService.track({
			name: "Wallet Owner Copy Wallet Owner Clicked"
		});
	}

	public trackCopyWalletHost(): void {
		this.segmentService.track({
			name: "Wallet Host Copy Wallet Host Clicked"
		});
		this.rudderstackService.track({
			name: "Wallet Host Copy Wallet Host Clicked"
		});
	}

	public trackCloseWalletAddress(): void {
		this.segmentService.track({
			name: "Wallet Address Close Clicked"
		});
		this.rudderstackService.track({
			name: "Wallet Address Close Clicked"
		});
	}

	public trackChangeNetworkClicked(): void {
		this.segmentService.track({
			name: "Change Network Clicked"
		});
		this.rudderstackService.track({
			name: "Change Network Clicked"
		});
	}
}
